// cache.js - Simple in-memory cache with TTL and invalidation

const cache = new Map();

// TTL constants
export const TTL = {
    SHORT: 60 * 1000,       // 1 minute
    MEDIUM: 5 * 60 * 1000,  // 5 minutes
    LONG: 15 * 60 * 1000    // 15 minutes
};

/**
 * Get a cached value if it exists and hasn't expired
 * @param {string} key - Cache key
 * @returns {any|null} - Cached value or null if not found/expired
 */
export function get(key) {
    const entry = cache.get(key);
    if (!entry) return null;

    if (Date.now() > entry.expiry) {
        cache.delete(key);
        return null;
    }

    return entry.data;
}

/**
 * Set a value in the cache with TTL
 * @param {string} key - Cache key
 * @param {any} data - Data to cache
 * @param {number} ttl - Time to live in milliseconds
 */
export function set(key, data, ttl = TTL.MEDIUM) {
    cache.set(key, {
        data,
        expiry: Date.now() + ttl
    });
}

/**
 * Invalidate cache entries matching a pattern
 * @param {string} pattern - Pattern to match (supports prefix matching with *)
 */
export function invalidate(pattern) {
    if (pattern.endsWith('*')) {
        const prefix = pattern.slice(0, -1);
        for (const key of cache.keys()) {
            if (key.startsWith(prefix)) {
                cache.delete(key);
            }
        }
    } else {
        cache.delete(pattern);
    }
}

/**
 * Clear all cache entries
 */
export function clearAll() {
    cache.clear();
}

// Build cache keys
export const CacheKeys = {
    items: (warehouseId) => `items_${warehouseId}`,
    transactions: (warehouseId) => `transactions_${warehouseId}`,
    todayTransactions: (warehouseId) => `todayTx_${warehouseId}`,
    salesTransactions: (warehouseId) => `salesTx_${warehouseId}`,
    salesTransactionsByDate: (warehouseId, date) => `salesTx_${warehouseId}_${date}`,
    salesTransactionsByMonth: (warehouseId, year, month) => `salesTx_${warehouseId}_${year}_${month}`,
    productionRecords: (warehouseId) => `production_${warehouseId}`
};
